import * as React from 'react';
import { cn } from '@/lib/utils';


const Card = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(

      'rounded-xl border bg-card text-card-foreground shadow font-circular',

      className
    )}
    {...props}
  />

));
Card.displayName = 'Card';


const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}

    className={cn('flex flex-col px-6 pt-6 gap-1', className)}
    {...props}
  />
));
CardHeader.displayName = 'CardHeader';


const CardTitle = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}

    className={cn(
      'font-semibold leading-none tracking-tight text-xl',
      className
    )}
    {...props}
  />
));
CardTitle.displayName = 'CardTitle';


const CardDescription = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}

    className={cn('text-sm text-muted-foreground font-circular', className)}
    {...props}
  />
));
CardDescription.displayName = 'CardDescription';


const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (

  <div ref={ref} className={cn('p-6 text-sm', className)} {...props} />
));
CardContent.displayName = 'CardContent';


const CardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}

    className={cn('flex items-center px-6 py-4', className)}
    {...props}
  />
));
CardFooter.displayName = 'CardFooter';

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardDescription,
  CardContent,
};

